module.exports = [

     
    {
        "organizationId": 3875,
        "companyName": "速顺物流",
        "companyAddr": "白云货运市场A4栋35-36档",
        "lon": "113.344385",
        "lat": "23.296426",
        "companyImgUrl1": "https://www.wy56.com/images/2019/05/05/tmb-80b154ed93ca4ad3906a6dd226dda090.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "速顺物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/05/05/tmb-9f825df9b7374c4db69017f9d23cf282.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "东莞市,株洲市,深圳市,郴州市,长沙市",
        "transitLocation": null,
        "timeLimitExplain": "1天,2天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": "",
        "serverName": "肖顺强",
        "servicePhoneNo": "13925140576",
        "directLineName": "广州市-东莞市,株洲市,深圳市,郴州市,长沙市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/05/05/tmb-80b154ed93ca4ad3906a6dd226dda090.jpg"
        ]
    },
    {
        "organizationId": 3871,
        "companyName": "广州市畅邮物流有限公司",
        "companyAddr": "白云货运市场A4栋37-39档",
        "lon": "113.344385",
        "lat": "23.296426",
        "companyImgUrl1": "https://www.wy56.com/images/2019/05/05/tmb-849bba997dee4b2c8dcd25b358a48c3a.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "广州市畅邮物流有限公司",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/05/05/tmb-16785d1a66204d72832d765ace19714b.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "兰州市,西宁市,银川市",
        "transitLocation": null,
        "timeLimitExplain": "3天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": "",
        "serverName": "陈露阳",
        "servicePhoneNo": "18664892133",
        "directLineName": "广州市-兰州市,西宁市,银川市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/05/05/tmb-849bba997dee4b2c8dcd25b358a48c3a.jpg"
        ]
    },
    {
        "organizationId": 3869,
        "companyName": "海口琼金海物流有限公司",
        "companyAddr": "白云货运市场二期A4栋41-42档",
        "lon": "113.344385",
        "lat": "23.296426",
        "companyImgUrl1": "https://www.wy56.com/images/2019/05/05/tmb-72953d134b404d18b82a7b9694af062a.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "琼金海物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/05/05/tmb-72d30a97dc904dbe9ff1904b6f446983.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "海口市",
        "transitLocation": null,
        "timeLimitExplain": "2-3天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": "海口三亚全境",
        "serverName": "彭思瑞",
        "servicePhoneNo": "13826457005",
        "directLineName": "广州市-海口市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/05/05/tmb-72953d134b404d18b82a7b9694af062a.jpg"
        ]
    },
    {
        "organizationId": 3867,
        "companyName": "烟台裕顺货运服务有限公司广州分公司",
        "companyAddr": "白云货运市场A4栋28-31档",
        "lon": "113.340975",
        "lat": "23.296629",
        "companyImgUrl1": "https://www.wy56.com/images/2019/05/05/tmb-aa4516f55aad4990918860cfb1022695.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/05/05/tmb-9bb47ad0827b49baacdee879f64d9281.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "裕顺货运",
        "companyLabel": "认证,金牌,往返,三方,专线",
        "companyLogo": "https://www.wy56.com/images/2019/05/05/tmb-b4fe50e61cc44a779630966667c3ab1f.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "烟台市",
        "transitLocation": null,
        "timeLimitExplain": "3天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": "烟台",
        "serverName": "所惠龙",
        "servicePhoneNo": "15999771183",
        "directLineName": "广州市-烟台市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/05/05/tmb-9bb47ad0827b49baacdee879f64d9281.jpg",
            "https://www.wy56.com/images/2019/05/05/tmb-aa4516f55aad4990918860cfb1022695.jpg"
        ]
    },
    {
        "organizationId": 3860,
        "companyName": "北京易元鑫航供应链管理有限公司",
        "companyAddr": "白云区太和镇昌和货运市场",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2019/05/05/tmb-5f4569f4e0034ad8b376902a73e8aa4c.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/05/05/tmb-58b4570ad95a4011afa50e50d0f17fb2.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "京铁易元",
        "companyLabel": "认证,往返,甩挂,三方,专线,仓储",
        "companyLogo": "https://www.wy56.com/images/2019/05/05/tmb-4780038be2694513ae4b3cadc804bd5a.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": ",北京市",
        "transitLocation": null,
        "timeLimitExplain": "4天,5天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": "",
        "serverName": "刘燕波",
        "servicePhoneNo": "15601005016",
        "directLineName": "广州市-北京市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/05/05/tmb-58b4570ad95a4011afa50e50d0f17fb2.jpg",
            "https://www.wy56.com/images/2019/05/05/tmb-5f4569f4e0034ad8b376902a73e8aa4c.jpg"
        ]
    },
    {
        "organizationId": 3857,
        "companyName": "广州市湘粮物流有限公司",
        "companyAddr": "广州市白云区太和镇林安物流园六街西面5--7档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2019/04/30/tmb-3f702d612c7745d8ae0941e2f6644d84.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/04/30/tmb-50f5cc3cb97945f2aee5d32215840f73.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2019/04/30/tmb-895643278f3149aa9675698b355d197a.jpg",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "广州市湘粮物流有限公司",
        "companyLabel": "往返,三方,专线",
        "companyLogo": "https://www.wy56.com/images/2019/04/30/tmb-13e19757759f48cd86b0b2d5d8671185.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "常德市,张家界市",
        "transitLocation": null,
        "timeLimitExplain": "3天,4天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": "",
        "serverName": "何哲武",
        "servicePhoneNo": "18675867599",
        "directLineName": "广州市-常德市,张家界市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/04/30/tmb-50f5cc3cb97945f2aee5d32215840f73.jpg",
            "https://www.wy56.com/images/2019/04/30/tmb-895643278f3149aa9675698b355d197a.jpg",
            "https://www.wy56.com/images/2019/04/30/tmb-3f702d612c7745d8ae0941e2f6644d84.jpg"
        ]
    },
    {
        "organizationId": 3667,
        "companyName": "仨鑫物流",
        "companyAddr": "广州市沙太北路琪骏南场K栋139-141号",
        "lon": "113.352810",
        "lat": "23.270444",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/25/tmb-9af33c71ed2f4ef3bf0b473a29a66b02.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "仨鑫物流",
        "companyLabel": "往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/25/tmb-bd7dc0f698274fa2ac10162ffcdffc2a.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "宿迁市",
        "transitLocation": null,
        "timeLimitExplain": "预计2-3天左右",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "饶先生",
        "servicePhoneNo": "13802781059",
        "directLineName": "广州市-宿迁市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/25/tmb-9af33c71ed2f4ef3bf0b473a29a66b02.jpg"
        ]
    },
    {
        "organizationId": 3664,
        "companyName": "万帮物流",
        "companyAddr": "广州市白云区沙太北路骐骏北场中区10号仓",
        "lon": "113.352810",
        "lat": "23.270444",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/25/tmb-9e902657cc274fc2ba29d4d74863c245.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "万帮物流",
        "companyLabel": "往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/25/tmb-b88e9a22b69346a892660f22b18e482f.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "安庆市,池州市",
        "transitLocation": null,
        "timeLimitExplain": "预计2-3天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "杨三",
        "servicePhoneNo": "13922768377",
        "directLineName": "广州市-安庆市,池州市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/25/tmb-9e902657cc274fc2ba29d4d74863c245.jpg"
        ]
    },
    {
        "organizationId": 3623,
        "companyName": "成鑫鹏物流",
        "companyAddr": "白云货运市场C1栋143档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/22/tmb-386a1b1ca6b54f62b83e21e64e2fb055.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "成鑫鹏物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/22/tmb-de02053784954118a5970384066ce7a6.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "沧州市",
        "transitLocation": null,
        "timeLimitExplain": "3-4天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "帅立果",
        "servicePhoneNo": "18529218558",
        "directLineName": "广州市-沧州市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/22/tmb-386a1b1ca6b54f62b83e21e64e2fb055.jpg"
        ]
    },
    {
        "organizationId": 3620,
        "companyName": "广州邯郸快运",
        "companyAddr": "白云货运市场C1-146",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/22/tmb-aca7cf820fbd4c9694c567db88f050b5.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "邯郸快运",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/22/tmb-255123fdadd4442b9f99dc1b892c0516.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "邢台市,邯郸市",
        "transitLocation": null,
        "timeLimitExplain": "3-4天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "王震",
        "servicePhoneNo": "13802992141",
        "directLineName": "广州市-邢台市,邯郸市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/22/tmb-aca7cf820fbd4c9694c567db88f050b5.jpg"
        ]
    },
    {
        "organizationId": 3616,
        "companyName": "广州市江和行物流有限公司",
        "companyAddr": "白云货运市场C1栋130-131档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/22/tmb-011523bb6f994cb3805c5436fda9a952.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "江和行物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/22/tmb-a46fcfe7739e4c55bfa7678c7669d4e9.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "平顶山市",
        "transitLocation": null,
        "timeLimitExplain": "3-4天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "刘石荣",
        "servicePhoneNo": "13828499393",
        "directLineName": "广州市-平顶山市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/22/tmb-011523bb6f994cb3805c5436fda9a952.jpg"
        ]
    },
    {
        "organizationId": 3613,
        "companyName": "广州市大华物流有限公司",
        "companyAddr": "白云货运市场C1栋139档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/22/tmb-0739700e71d24c2a8ace8ed0e1b203b5.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "大华物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/22/tmb-7c5a05db0f224169978be8c77533dac5.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "周口市",
        "transitLocation": null,
        "timeLimitExplain": "3-4天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "郑玮",
        "servicePhoneNo": "13138629058",
        "directLineName": "广州市-周口市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/22/tmb-0739700e71d24c2a8ace8ed0e1b203b5.jpg"
        ]
    },
    {
        "organizationId": 3611,
        "companyName": "广州华丰物流",
        "companyAddr": "白云货运市场C1栋142-143档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/22/tmb-d16281630fdf43d2a84d3bc1dd51dca5.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "华丰物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/22/tmb-9b5c403fce0247539aff399d2c4ad33f.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "长沙市",
        "transitLocation": null,
        "timeLimitExplain": "2天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "李丰",
        "servicePhoneNo": "13250747408",
        "directLineName": "广州市-长沙市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/22/tmb-d16281630fdf43d2a84d3bc1dd51dca5.jpg"
        ]
    },
    {
        "organizationId": 3609,
        "companyName": "冠晖物流",
        "companyAddr": "白云货运市场C1栋137-138档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/22/tmb-4c4abd8c18a54d199972ada701c5ce44.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "冠晖物流",
        "companyLabel": "认证,金牌,专线,单边",
        "companyLogo": "https://www.wy56.com/images/2019/03/22/tmb-5d1f6035da8440eb8acf5e86c0c4b4e3.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "南阳市",
        "transitLocation": null,
        "timeLimitExplain": "3天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "李喜运",
        "servicePhoneNo": "13268128333",
        "directLineName": "广州市-南阳市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/22/tmb-4c4abd8c18a54d199972ada701c5ce44.jpg"
        ]
    },
    {
        "organizationId": 3607,
        "companyName": "广州市玖洲物流有限责任公司",
        "companyAddr": "白云货运市场C1栋133-134档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/22/tmb-a058f8683741402f8646874a4355790a.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/22/tmb-271296e0675a46d2b8d1cff2d9fae6ad.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "玖洲物流",
        "companyLabel": "认证,金牌,往返,专线,单边",
        "companyLogo": "https://www.wy56.com/images/2019/03/22/tmb-92dadffbb6e84cd98340cf18b0385b16.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "郑州市",
        "transitLocation": null,
        "timeLimitExplain": "2-3天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "段加松",
        "servicePhoneNo": "13925156769",
        "directLineName": "广州市-郑州市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/22/tmb-271296e0675a46d2b8d1cff2d9fae6ad.jpg",
            "https://www.wy56.com/images/2019/03/22/tmb-a058f8683741402f8646874a4355790a.jpg"
        ]
    },
    {
        "organizationId": 3605,
        "companyName": "广州德星物流有限公司",
        "companyAddr": "白云货运市场二期B2栋106档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/22/tmb-14d1280905ef44349a7e685323c8e401.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "德星物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/22/tmb-c87af2d015e649e491474ec82cc7a67d.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "郑州市",
        "transitLocation": null,
        "timeLimitExplain": "3-4天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "康勇",
        "servicePhoneNo": "13925049858",
        "directLineName": "广州市-郑州市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/22/tmb-14d1280905ef44349a7e685323c8e401.jpg"
        ]
    },
    {
        "organizationId": 3602,
        "companyName": "北京鲁青运输服务有限公司",
        "companyAddr": "白云货运市场二期A4栋15.16档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/22/tmb-979043761df84022904a6dd399d82480.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "北京鲁青运输服务有限公司",
        "companyLabel": "认证,金牌,专线,单边",
        "companyLogo": "https://www.wy56.com/images/2019/03/22/tmb-fa258627195c4b15a706349b02bf42a1.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "济南市,青岛市",
        "destCity": "",
        "transitLocation": null,
        "timeLimitExplain": "4-5天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "杨志伟",
        "servicePhoneNo": "13500267568",
        "directLineName": "",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/22/tmb-979043761df84022904a6dd399d82480.jpg"
        ]
    },
    {
        "organizationId": 3597,
        "companyName": "万连货运大连往返专线",
        "companyAddr": "白云货运市场3号门中心1号仓5号门",
        "lon": "113.340646",
        "lat": "23.295486",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/21/879450b36425452ea52447a09e84da8d.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/21/3ca1b8579a3e48caa0ad4010448f5a9b.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "万连货运",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/21/388fe6bfd5064bc5b69a550b5f2f8855.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "大连市",
        "transitLocation": null,
        "timeLimitExplain": "3-4天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "杨春晖",
        "servicePhoneNo": "13478526888",
        "directLineName": "广州市-大连市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/21/3ca1b8579a3e48caa0ad4010448f5a9b.jpg",
            "https://www.wy56.com/images/2019/03/21/879450b36425452ea52447a09e84da8d.jpg"
        ]
    },
    {
        "organizationId": 3595,
        "companyName": "聚亨物流",
        "companyAddr": "白云货运市场B2栋130",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/21/eeeec9110d194c878cfc40f5a52150b9.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/21/4e6b44a80eff4439a1d2b2ef9bf26ced.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "聚亨物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/21/836b8c049be7416e94dd534b2fe5059e.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "上海市",
        "transitLocation": null,
        "timeLimitExplain": "3天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "聚亨周经理",
        "servicePhoneNo": "13725270676",
        "directLineName": "广州市-上海市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/21/4e6b44a80eff4439a1d2b2ef9bf26ced.jpg",
            "https://www.wy56.com/images/2019/03/21/eeeec9110d194c878cfc40f5a52150b9.jpg"
        ]
    },
    {
        "organizationId": 3590,
        "companyName": "晋长高物流服务公司",
        "companyAddr": "白云货运市场A4栋3-6档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/21/cee0f431561c4b6882ef971f30361cf5.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "晋长高物流服务公司",
        "companyLabel": "认证,金牌,往返",
        "companyLogo": "https://www.wy56.com/images/2019/03/21/cdd735993c554ae696cfce86719dfb62.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "晋城市,长治市",
        "transitLocation": null,
        "timeLimitExplain": "3-4天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "冯兴强",
        "servicePhoneNo": "15918872121",
        "directLineName": "广州市-晋城市,长治市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/21/cee0f431561c4b6882ef971f30361cf5.jpg"
        ]
    },
    {
        "organizationId": 3588,
        "companyName": "山西新万通物流广州公司",
        "companyAddr": "白云货运市场A4栋3-6档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/21/7410257a9e3c4e02a52611f618a35421.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "山西新万通物流广州公司",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/21/0bb705870d8e4e2e93f1937c4c58a79a.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "晋城市",
        "transitLocation": null,
        "timeLimitExplain": "3-4天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "吕帅",
        "servicePhoneNo": "15915756690",
        "directLineName": "广州市-晋城市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/21/7410257a9e3c4e02a52611f618a35421.jpg"
        ]
    },
    {
        "organizationId": 3586,
        "companyName": "城都天顺祥物流有限公司",
        "companyAddr": "白云货运市场A4栋24号",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/21/3b29967502574f1383a9bbaeb8380ccc.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "天顺祥物流",
        "companyLabel": "认证,金牌,专线,仓储,单边",
        "companyLogo": "https://www.wy56.com/images/2019/03/21/21dbdde7307c43d1baee6dd182c9a780.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "成都市",
        "transitLocation": null,
        "timeLimitExplain": "2天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "天顺祥谢经理",
        "servicePhoneNo": "13926048850",
        "directLineName": "广州市-成都市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/21/3b29967502574f1383a9bbaeb8380ccc.jpg"
        ]
    },
    {
        "organizationId": 3582,
        "companyName": "新乡市广清物流有限公司",
        "companyAddr": "白云货运市场C4栋118-120档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/21/ff616a8e53da42e4a61ebc98b42d68f8.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "广清物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/21/3ee4053e3489492db3be65bb6d8348db.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "新乡市",
        "transitLocation": null,
        "timeLimitExplain": "3天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "李义",
        "servicePhoneNo": "13600494189",
        "directLineName": "广州市-新乡市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/21/ff616a8e53da42e4a61ebc98b42d68f8.jpg"
        ]
    },
    {
        "organizationId": 3577,
        "companyName": "广州鼎立物流有限公司",
        "companyAddr": "白云货运市场一期中心仓1-2号",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/20/5473d333870a49a598c64543f28e5db4.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "鼎立物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/20/93bd04cbba474b6aba6358e7d28d69ec.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "北京市,天津市,廊坊市",
        "transitLocation": null,
        "timeLimitExplain": "3-4天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "余振超",
        "servicePhoneNo": "15622151562",
        "directLineName": "广州市-北京市,天津市,廊坊市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/20/5473d333870a49a598c64543f28e5db4.jpg"
        ]
    },
    {
        "organizationId": 3571,
        "companyName": "广州华舟物流有限公司",
        "companyAddr": "白云货运市场C栋115档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/20/bc96a376e9384b05b895bf347c2dd982.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/20/afdaa7674eba4c0bbacffa47f8e6d926.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "华舟物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/20/c21ada30dbf24ac18f880debe7ed0dfa.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "成都市",
        "transitLocation": null,
        "timeLimitExplain": "3天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "邹华均",
        "servicePhoneNo": "13138613885",
        "directLineName": "广州市-成都市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/20/afdaa7674eba4c0bbacffa47f8e6d926.jpg",
            "https://www.wy56.com/images/2019/03/20/bc96a376e9384b05b895bf347c2dd982.jpg"
        ]
    },
    {
        "organizationId": 3569,
        "companyName": "广州粤顺通物流有限公司",
        "companyAddr": "白云货运市场A2栋127-129档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/20/19a3fe4274b34dd89d61691efd0ca5e6.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "粤顺通物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/20/7dee438b65854d3bb8bb334892ab6c47.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "中山市",
        "transitLocation": null,
        "timeLimitExplain": "1天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "孙建国",
        "servicePhoneNo": "18924165225",
        "directLineName": "广州市-中山市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/20/19a3fe4274b34dd89d61691efd0ca5e6.jpg"
        ]
    },
    {
        "organizationId": 3565,
        "companyName": "中成货运有限公司",
        "companyAddr": "白云货运市场C1栋108-110",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/20/df5ecd0459924473a8f0e0c3f1903140.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "中成物流",
        "companyLabel": "认证,金牌,专线,单边",
        "companyLogo": "https://www.wy56.com/images/2019/03/20/2a2bda35f45a48ba9c70d06f3c7d0461.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "汕头市",
        "destCity": "广州市",
        "transitLocation": null,
        "timeLimitExplain": "2天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "刘小平",
        "servicePhoneNo": "13553889156",
        "directLineName": "汕头市-广州市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/20/df5ecd0459924473a8f0e0c3f1903140.jpg"
        ]
    },
    {
        "organizationId": 3562,
        "companyName": "广州（普粤）荣盛物流有限公司",
        "companyAddr": "白云货运市场B1栋133-134档",
        "lon": "113.340975",
        "lat": "23.296629",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/16/d1fd8db407554428bd55f7837800fe02.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/16/edf632c4b9074f1b9b4e60a394f6bd19.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "（普粤）荣盛物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/16/0450b5d6b1a14cc0a100b4ace950432c.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "揭阳市,汕尾市,潮州市",
        "transitLocation": null,
        "timeLimitExplain": "2天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": "",
        "serverName": "余泽汉",
        "servicePhoneNo": "13423644436",
        "directLineName": "广州市-揭阳市,汕尾市,潮州市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/16/d1fd8db407554428bd55f7837800fe02.jpg",
            "https://www.wy56.com/images/2019/03/16/edf632c4b9074f1b9b4e60a394f6bd19.jpg"
        ]
    },
    {
        "organizationId": 3560,
        "companyName": "广州鑫鸿运物流有限公司",
        "companyAddr": "白云货运市场B2栋102-103档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/20/476be9fadcf1444c8835c7d51c64acd5.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "鑫鸿运物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/20/d9748c29bc1145a8bdda4e88fee04f74.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "大连市",
        "transitLocation": null,
        "timeLimitExplain": "3-4天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "董德攀",
        "servicePhoneNo": "13560213111",
        "directLineName": "广州市-大连市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/20/476be9fadcf1444c8835c7d51c64acd5.jpg"
        ]
    },
    {
        "organizationId": 3557,
        "companyName": "广州佛系缘物流有限公司",
        "companyAddr": "白云区太和镇白云货运市场B1栋127-128档",
        "lon": "113.340975",
        "lat": "23.296629",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/15/a04b459ecf7e4f01a42cdb661a00d068.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/15/a462ba21dbf94cb7a98cda44b4247623.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "佛系缘物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/15/867e5a34342e46bdaafe5169181f5ba9.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "东莞市,佛山市",
        "transitLocation": null,
        "timeLimitExplain": "1天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "齐鸿刚",
        "servicePhoneNo": "13250266860",
        "directLineName": "广州市-东莞市,佛山市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/15/a462ba21dbf94cb7a98cda44b4247623.jpg",
            "https://www.wy56.com/images/2019/03/15/a04b459ecf7e4f01a42cdb661a00d068.jpg"
        ]
    },
    {
        "organizationId": 3540,
        "companyName": "广州市苏丰物流有限公司",
        "companyAddr": "白云货运市场3号门7号仓8-15档",
        "lon": "113.340646",
        "lat": "23.295486",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/19/8ec7a10eb05d4d4baf285828041e3518.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/19/ed346329db694370b064134911e6e82c.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2019/03/19/9bc113b3de72447f9db63b8b0960a62f.jpg",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "苏丰物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/19/6aa08baa5ada4f1681ab75695c1f3e0f.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "扬州市,泰州市,盐城市",
        "transitLocation": null,
        "timeLimitExplain": "3-4天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "彭治英",
        "servicePhoneNo": "18818846733",
        "directLineName": "广州市-扬州市,泰州市,盐城市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/19/9bc113b3de72447f9db63b8b0960a62f.jpg",
            "https://www.wy56.com/images/2019/03/19/8ec7a10eb05d4d4baf285828041e3518.jpg",
            "https://www.wy56.com/images/2019/03/19/ed346329db694370b064134911e6e82c.jpg"
        ]
    },
    {
        "organizationId": 3499,
        "companyName": "广州市文俊快运",
        "companyAddr": "白云货运市场二期C4栋108-109档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/19/f9a3876db7eb432987e4b11fc0e9409c.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/19/0c37750658d04315a48efa06e5cca1db.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "文俊物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/19/4814bac436a74098abcfda88d12024e4.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "晋城市,焦作市",
        "transitLocation": null,
        "timeLimitExplain": "4-5天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "赵文革",
        "servicePhoneNo": "13826203339",
        "directLineName": "广州市-晋城市,焦作市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/19/f9a3876db7eb432987e4b11fc0e9409c.jpg",
            "https://www.wy56.com/images/2019/03/19/0c37750658d04315a48efa06e5cca1db.jpg"
        ]
    },
    {
        "organizationId": 3496,
        "companyName": "广州新达物流商丘专线",
        "companyAddr": "白云货运市场C1栋147档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/19/a827e9e4cb594bf983e14a526a4f036d.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "新达物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/19/e526bb8719b047cb8f464b00290f00ff.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "商丘市",
        "transitLocation": null,
        "timeLimitExplain": "2-3天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "贾新建",
        "servicePhoneNo": "13535529998",
        "directLineName": "广州市-商丘市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/19/a827e9e4cb594bf983e14a526a4f036d.jpg"
        ]
    },
    {
        "organizationId": 3493,
        "companyName": "广州市鑫缘物流",
        "companyAddr": "白云货运市场B2栋101档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/19/4b1f7db9ec494bc188cac6adb7af69ed.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "鑫缘物流",
        "companyLabel": "认证,金牌,专线,单边",
        "companyLogo": "https://www.wy56.com/images/2019/03/19/51976a201f8a456488f6d21f15b5b50f.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "哈尔滨市,长春市",
        "destCity": "",
        "transitLocation": null,
        "timeLimitExplain": "4-5天,5-6天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": "",
        "serverName": "张卫东",
        "servicePhoneNo": "13189053888",
        "directLineName": "",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/19/4b1f7db9ec494bc188cac6adb7af69ed.jpg"
        ]
    },
    {
        "organizationId": 3488,
        "companyName": "上海巍昊物流有限公司",
        "companyAddr": "广东省广州市白云区太和镇沙太北路丰和南场F1栋101-105档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/19/ae41ba0c3b1b46c88ef569273c4ea8b0.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/19/8d9f4c2456e4484493a02b5548fce909.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2019/03/19/894c4e32f2d1417bb26b35cec904c6eb.jpg",
        "companyImgUrl4": "https://www.wy56.com/images/2019/03/19/a947b0c8429b4b38b0c60a01fa328e5a.jpg",
        "companyImgUrl5": "https://www.wy56.com/images/2019/03/19/87638bded4234e7da71e920684921a2e.jpg",
        "nodeNickName": "上海巍昊物流有限公司",
        "companyLabel": "认证,金牌,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/19/8ebcd1fb916148ac8a8dc9284e1bcd23.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "上海市",
        "transitLocation": null,
        "timeLimitExplain": "3天",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2019/03/19/eab082cb1e8d4a12a94fb32e55867945.jpg",
        "businessRouteLine": null,
        "serverName": "魏才茂",
        "servicePhoneNo": "13560056963",
        "directLineName": "广州市-上海市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/19/a947b0c8429b4b38b0c60a01fa328e5a.jpg",
            "https://www.wy56.com/images/2019/03/19/ae41ba0c3b1b46c88ef569273c4ea8b0.jpg",
            "https://www.wy56.com/images/2019/03/19/894c4e32f2d1417bb26b35cec904c6eb.jpg",
            "https://www.wy56.com/images/2019/03/19/8d9f4c2456e4484493a02b5548fce909.jpg",
            "https://www.wy56.com/images/2019/03/19/87638bded4234e7da71e920684921a2e.jpg"
        ]
    },
    {
        "organizationId": 3481,
        "companyName": "广东德坤物流有限公司",
        "companyAddr": "广东省广州市白云区沙太北路丰和物流园F8108-110档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/19/eef4d76a3c46463f937fb1f7b041d779.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/19/4b6735a683aa4a7b9b9451848e6f6801.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2019/03/19/8ec2f04ba7aa4226b33e5c63307973f8.jpg",
        "companyImgUrl4": "https://www.wy56.com/images/2019/03/19/f47f39f80dcc4caebc3dec2465139592.jpg",
        "companyImgUrl5": "https://www.wy56.com/images/2019/03/19/944869a15de14b62981eb3a785c76d49.jpg",
        "nodeNickName": "广东德坤物流有限公司",
        "companyLabel": "认证,金牌,三方",
        "companyLogo": "https://www.wy56.com/images/2019/03/19/f17d4197086e481f9c006608e4333d83.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": null,
        "isHangUp": null,
        "startCity": null,
        "destCity": "",
        "transitLocation": null,
        "timeLimitExplain": null,
        "bussinessLicenseUrl": "https://www.wy56.com/images/2019/03/19/1b39832e9c3e4ffba7bd477fdd2cdfe5.jpg",
        "businessRouteLine": null,
        "serverName": "余宗辉",
        "servicePhoneNo": "18025371668",
        "directLineName": "",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/19/f47f39f80dcc4caebc3dec2465139592.jpg",
            "https://www.wy56.com/images/2019/03/19/8ec2f04ba7aa4226b33e5c63307973f8.jpg",
            "https://www.wy56.com/images/2019/03/19/eef4d76a3c46463f937fb1f7b041d779.jpg",
            "https://www.wy56.com/images/2019/03/19/4b6735a683aa4a7b9b9451848e6f6801.jpg",
            "https://www.wy56.com/images/2019/03/19/944869a15de14b62981eb3a785c76d49.jpg"
        ]
    },
    {
        "organizationId": 3473,
        "companyName": "广州金山运输有限公司",
        "companyAddr": "白云货运市场B2栋121档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/18/65037e024c6e4725bab35710036a15aa.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "金山物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/18/d12fc22076e84de082e750b5233240e3.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "揭阳市,汕头市",
        "transitLocation": null,
        "timeLimitExplain": "2天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "王雄生",
        "servicePhoneNo": "13602747078",
        "directLineName": "广州市-揭阳市,汕头市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/18/65037e024c6e4725bab35710036a15aa.jpg"
        ]
    },
    {
        "organizationId": 3460,
        "companyName": "金昌物流",
        "companyAddr": "白云货运市场B2栋124-125档",
        "lon": "113.340975",
        "lat": "23.296629",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/18/24e4b61b183e4b06a337b1199eed3020.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/18/27a1d904cc764c9b882463fc28fe3bb3.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "金昌物流",
        "companyLabel": "认证,金牌,专线,单边",
        "companyLogo": "https://www.wy56.com/images/2019/03/18/baad1cb6cb9d450a8ecab485fe183249.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "包头市,北京市,呼和浩特市,沧州市,济南市,济宁市",
        "transitLocation": null,
        "timeLimitExplain": "4-5天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "袁小高",
        "servicePhoneNo": "18922363089",
        "directLineName": "广州市-包头市,北京市,呼和浩特市,沧州市,济南市,济宁市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/18/24e4b61b183e4b06a337b1199eed3020.jpg",
            "https://www.wy56.com/images/2019/03/18/27a1d904cc764c9b882463fc28fe3bb3.jpg"
        ]
    },
    {
        "organizationId": 3453,
        "companyName": "广州市沧顺物流有限公司",
        "companyAddr": "白云货运市场C3栋1-4仓库",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/18/a1a37baa1ac5445a8535b95f53c6d161.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "沧顺物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/18/d05363d1f31042cf9011bcebb69bf476.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "北京市,天津市",
        "transitLocation": null,
        "timeLimitExplain": "3-4天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "迟鹏冲",
        "servicePhoneNo": "13928796533",
        "directLineName": "广州市-北京市,天津市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/18/a1a37baa1ac5445a8535b95f53c6d161.jpg"
        ]
    },
    {
        "organizationId": 3438,
        "companyName": "广州汕友物流有限公司",
        "companyAddr": "白云货运市场C4栋117档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/12/27/209e71537da2412e92a8629ac54042ae.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/12/27/0a125d470cec4594a97689b66ed841ea.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2018/12/27/227756e1ade24dbab119ebc8bae2dce3.jpg",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "汕友物流",
        "companyLabel": "金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2018/12/27/d7b8a1a5993842d0aedc51ed807bfa4a.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市,汕头市",
        "destCity": "揭阳市,汕头市,汕尾市",
        "transitLocation": null,
        "timeLimitExplain": "2天",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/12/27/2af325231ef7400bb1f700db26e91f76.jpg",
        "businessRouteLine": null,
        "serverName": "梁素娟",
        "servicePhoneNo": "15989051899",
        "directLineName": "广州市,汕头市-揭阳市,汕头市,汕尾市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/12/27/227756e1ade24dbab119ebc8bae2dce3.jpg",
            "https://www.wy56.com/images/2018/12/27/0a125d470cec4594a97689b66ed841ea.jpg",
            "https://www.wy56.com/images/2018/12/27/209e71537da2412e92a8629ac54042ae.jpg"
        ]
    },
    {
        "organizationId": 3401,
        "companyName": "广州合协物流有限公司",
        "companyAddr": "白云货运市场北场C4栋116档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/18/164a4e84e6f245ebb9abb5036ccae3fa.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "合协物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/18/249a954953824d5f9a30264e4417208f.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "常德市",
        "transitLocation": null,
        "timeLimitExplain": "2天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "李喜华",
        "servicePhoneNo": "18665592618",
        "directLineName": "广州市-常德市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/18/164a4e84e6f245ebb9abb5036ccae3fa.jpg"
        ]
    },
    {
        "organizationId": 3373,
        "companyName": "万发物流白云分公司",
        "companyAddr": "白云区太和镇白云货运市场一号门C栋108.126档",
        "lon": "113.345699",
        "lat": "23.298100",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/18/4c42d3a830074f8a93a6c1f42476fa48.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/18/0a0dc94c695a4aa6ac50ff96d26da311.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "万发物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/18/b32306d3245847ed86292c247b75862e.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "哈尔滨市,沈阳市,长春市",
        "transitLocation": null,
        "timeLimitExplain": "2-3天,3-4天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "庄婷婷",
        "servicePhoneNo": "15915858801",
        "directLineName": "广州市-哈尔滨市,沈阳市,长春市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/18/0a0dc94c695a4aa6ac50ff96d26da311.jpg",
            "https://www.wy56.com/images/2019/03/18/4c42d3a830074f8a93a6c1f42476fa48.jpg"
        ]
    },
    {
        "organizationId": 3341,
        "companyName": "广西玉柴物流股份有限公司广州分公司",
        "companyAddr": "白云货运市场C4-112档",
        "lon": "113.340975",
        "lat": "23.296629",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/18/9368816511a54e5c8e961f15f31948aa.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "玉柴物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/18/be79e38731174f599846a5dfdda7c473.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "玉林市",
        "transitLocation": null,
        "timeLimitExplain": "2-3天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "温杰强",
        "servicePhoneNo": "13172084703",
        "directLineName": "广州市-玉林市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/18/9368816511a54e5c8e961f15f31948aa.jpg"
        ]
    },
    {
        "organizationId": 3338,
        "companyName": "广州骅强物流有限公司",
        "companyAddr": "白云货运市场C4栋114档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/18/b5c3288989a542fc8152826bfeedf820.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "骅强物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/18/d42e681073f941909972ef1acfa76d2f.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "东莞市",
        "transitLocation": null,
        "timeLimitExplain": "1天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "朱伟强",
        "servicePhoneNo": "13922161621",
        "directLineName": "广州市-东莞市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/18/b5c3288989a542fc8152826bfeedf820.jpg"
        ]
    },
    {
        "organizationId": 3336,
        "companyName": "恒路物流股份有限公司太和分公司",
        "companyAddr": "白云区太和镇白云货运市场C栋101档",
        "lon": "113.345699",
        "lat": "23.298100",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/18/33fbd6c8943b4744ad017b82be90d6d4.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/18/816d368a18474bdb9c84a8e540518d18.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "恒路物流",
        "companyLabel": "认证,金牌,三方,单边",
        "companyLogo": "https://www.wy56.com/images/2019/03/18/9fc7dc7113434b9db1639f7aed81626e.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "广州市",
        "transitLocation": null,
        "timeLimitExplain": "一天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "李小龙",
        "servicePhoneNo": "18922456612",
        "directLineName": "广州市-广州市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/18/816d368a18474bdb9c84a8e540518d18.jpg",
            "https://www.wy56.com/images/2019/03/18/33fbd6c8943b4744ad017b82be90d6d4.jpg"
        ]
    },
    {
        "organizationId": 3334,
        "companyName": "广州市锦遥物流有限公司",
        "companyAddr": "白云货运市场A4-06档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2018/12/28/d06fa2ea147842bb8f96f92de38a8b51.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/12/28/674faf14cd33415fbad8a2b8dbfb6c1c.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2018/12/28/9192e5b35c9f4ea49f1c9807a540d503.jpg",
        "companyImgUrl4": "https://www.wy56.com/images/2018/12/28/c138f36dda614c15ae4c01c3c2aac328.jpg",
        "companyImgUrl5": "",
        "nodeNickName": "广州市锦遥物流有限公司",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2018/12/28/d83fec48b6c2461485d85046a8c1ad6c.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "太原市",
        "transitLocation": null,
        "timeLimitExplain": "3天",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/12/28/0331fdce6d9240648b175f035921efc7.jpg",
        "businessRouteLine": null,
        "serverName": "宋志强",
        "servicePhoneNo": "13533602566",
        "directLineName": "广州市-太原市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/12/28/d06fa2ea147842bb8f96f92de38a8b51.jpg",
            "https://www.wy56.com/images/2018/12/28/674faf14cd33415fbad8a2b8dbfb6c1c.jpg",
            "https://www.wy56.com/images/2018/12/28/c138f36dda614c15ae4c01c3c2aac328.jpg",
            "https://www.wy56.com/images/2018/12/28/9192e5b35c9f4ea49f1c9807a540d503.jpg"
        ]
    },
    {
        "organizationId": 3314,
        "companyName": "武汉纪晖物流",
        "companyAddr": "白云货运市场3号门H栋108-109档",
        "lon": "113.340646",
        "lat": "23.295486",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/18/8b96607c1d484f6f95de1110b60836a4.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/18/6ddbbe7b364848aa96ad30df62c94e45.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "纪晖物流",
        "companyLabel": "认证,金牌,单边",
        "companyLogo": "https://www.wy56.com/images/2019/03/18/1459099a74e4406e912034a3a1d31e62.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "武汉市",
        "destCity": "广州市",
        "transitLocation": null,
        "timeLimitExplain": "2天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "袁丽丽",
        "servicePhoneNo": "15820392934",
        "directLineName": "武汉市-广州市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/18/6ddbbe7b364848aa96ad30df62c94e45.jpg",
            "https://www.wy56.com/images/2019/03/18/8b96607c1d484f6f95de1110b60836a4.jpg"
        ]
    },
    {
        "organizationId": 3300,
        "companyName": "广州海汌物流有限公司",
        "companyAddr": "白云货运市场南场K栋1-3档",
        "lon": "113.340808",
        "lat": "23.294813",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/16/a0334e97e9af4dff8539832f7132df66.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/16/6b66991318554dad8a8ab6972ae95eb5.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2019/03/16/0273b8670aa448e594f6a6a1234ad709.jpg",
        "companyImgUrl4": "https://www.wy56.com/images/2019/03/16/93354990b1194eb7a71f4f434e873d59.jpg",
        "companyImgUrl5": "https://www.wy56.com/images/2019/03/16/64f306c43d444e998751ada1e7eeedf2.jpg",
        "nodeNickName": "海汌物流",
        "companyLabel": "认证,金牌,三方,商品车运输",
        "companyLogo": "https://www.wy56.com/images/2019/03/16/b2ca603b84d54e68b5e1fa1cfe02e95e.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": null,
        "isHangUp": null,
        "startCity": null,
        "destCity": "",
        "transitLocation": null,
        "timeLimitExplain": null,
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "严坚",
        "servicePhoneNo": "15889933100",
        "directLineName": "",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/16/64f306c43d444e998751ada1e7eeedf2.jpg",
            "https://www.wy56.com/images/2019/03/16/0273b8670aa448e594f6a6a1234ad709.jpg",
            "https://www.wy56.com/images/2019/03/16/a0334e97e9af4dff8539832f7132df66.jpg",
            "https://www.wy56.com/images/2019/03/16/93354990b1194eb7a71f4f434e873d59.jpg",
            "https://www.wy56.com/images/2019/03/16/6b66991318554dad8a8ab6972ae95eb5.jpg"
        ]
    },
    {
        "organizationId": 3298,
        "companyName": "深圳市煌烁物流有限公司",
        "companyAddr": "白云货运市场B2栋122-123档",
        "lon": "113.340975",
        "lat": "23.296629",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/16/af90861ca73041d1ae184b49a9e21617.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/16/d9a75c1818cf4774b1bc9c0fb0e598a3.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "煌烁物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/16/2fdadf5b2dac4d70a32df0ea3a51d263.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "深圳市",
        "transitLocation": null,
        "timeLimitExplain": "预计1天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "叶虹均",
        "servicePhoneNo": "13265429818",
        "directLineName": "广州市-深圳市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/16/d9a75c1818cf4774b1bc9c0fb0e598a3.jpg",
            "https://www.wy56.com/images/2019/03/16/af90861ca73041d1ae184b49a9e21617.jpg"
        ]
    },
    {
        "organizationId": 3286,
        "companyName": "洛阳市凯安物流有限公司",
        "companyAddr": "白云货运市场C1栋114-116档",
        "lon": "113.340975",
        "lat": "23.296629",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/16/84043f989e424f8c8139092688323986.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/16/f4cc1c6460b44ee0a949c7e3873d27ce.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "凯安物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/16/e2e2d605cfcf46ed9f226a950401b27e.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "洛阳市",
        "transitLocation": null,
        "timeLimitExplain": "预计3-4天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "姚宗峰",
        "servicePhoneNo": "13826093660",
        "directLineName": "广州市-洛阳市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/16/f4cc1c6460b44ee0a949c7e3873d27ce.jpg",
            "https://www.wy56.com/images/2019/03/16/84043f989e424f8c8139092688323986.jpg"
        ]
    },
    {
        "organizationId": 3280,
        "companyName": "广州家鑫创联物流有限公司",
        "companyAddr": "林安物流园八街北栋8953-8955档",
        "lon": "113.359811",
        "lat": "23.266120",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/15/bc5053e6a33248e8aebe1d75be5a68a8.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "家鑫创联物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/15/74c23d4763404d0880b377fe7cea8599.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "韶关市",
        "transitLocation": null,
        "timeLimitExplain": "1-2天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "谢长发",
        "servicePhoneNo": "15360809896",
        "directLineName": "广州市-韶关市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/15/bc5053e6a33248e8aebe1d75be5a68a8.jpg"
        ]
    },
    {
        "organizationId": 3278,
        "companyName": "广州国友物流有限公司",
        "companyAddr": "白云区太和镇白云货运市场B1栋117档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/15/441019a44cf048f3a89e26dca91232c7.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "国友物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/15/3c7c8808fba14abb818f6db0d2200397.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "深圳市",
        "transitLocation": null,
        "timeLimitExplain": "预计1天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "王卫国",
        "servicePhoneNo": "13725402393",
        "directLineName": "广州市-深圳市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/15/441019a44cf048f3a89e26dca91232c7.jpg"
        ]
    },
    {
        "organizationId": 3274,
        "companyName": "广州市回头车物流有限公司",
        "companyAddr": "白云区太和镇白云货运市场二期B1栋126档",
        "lon": "113.340975",
        "lat": "23.296629",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/15/93b5b9343b7b4a7887a6e6138555e5af.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/15/b9b653a4c3f54f6eb4114c35445c06eb.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "回头车物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/15/8b9b1363aa8243019cbfca7cac2f38ed.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "江门市",
        "transitLocation": null,
        "timeLimitExplain": "预计2天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "吕志群",
        "servicePhoneNo": "13928931599",
        "directLineName": "广州市-江门市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/15/93b5b9343b7b4a7887a6e6138555e5af.jpg",
            "https://www.wy56.com/images/2019/03/15/b9b653a4c3f54f6eb4114c35445c06eb.jpg"
        ]
    },
    {
        "organizationId": 3271,
        "companyName": "惠州市惠城区豫兴物流代理服务部",
        "companyAddr": "白云货运市场B2栋133-134档",
        "lon": "113.340975",
        "lat": "23.296629",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/15/f8512651060649c6b0087a74f6ec9b6f.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/15/bbd30c815d7248a9b229836ee838a60d.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "豫兴物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/15/ca3451d7aac945dfa3f482756abb0b91.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "惠州市,海口市",
        "transitLocation": null,
        "timeLimitExplain": "预计1天,预计2天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "邢敏",
        "servicePhoneNo": "13928855028",
        "directLineName": "广州市-惠州市,海口市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/15/f8512651060649c6b0087a74f6ec9b6f.jpg",
            "https://www.wy56.com/images/2019/03/15/bbd30c815d7248a9b229836ee838a60d.jpg"
        ]
    },
    {
        "organizationId": 3269,
        "companyName": "广州市宝来物流有限公司",
        "companyAddr": "白云区太和镇白云货运市场二期B2栋114-115档",
        "lon": "113.340975",
        "lat": "23.296629",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/15/8cf6e25319df4cc5be0ec6ec4ba8c684.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "宝来物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/15/aaf9f30dcdbc4a13afab87959da9f620.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "汕头市",
        "transitLocation": null,
        "timeLimitExplain": "预计1-2天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "王清城",
        "servicePhoneNo": "13802736815",
        "directLineName": "广州市-汕头市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/15/8cf6e25319df4cc5be0ec6ec4ba8c684.jpg"
        ]
    },
    {
        "organizationId": 3267,
        "companyName": "广州市杰平物流有限公司",
        "companyAddr": "林安物流园六街东面655-656档",
        "lon": "113.359811",
        "lat": "23.266120",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/15/67454cbb1e0242fdb34e9d8c85cd3966.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "杰平物流",
        "companyLabel": "认证,往返,专线,金牌",
        "companyLogo": "https://www.wy56.com/images/2019/03/15/5794b4a7deb546c99f81e171370a72b4.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "临沂市",
        "transitLocation": null,
        "timeLimitExplain": "预计2-3天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "王玉辉",
        "servicePhoneNo": "13535451535",
        "directLineName": "广州市-临沂市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/15/67454cbb1e0242fdb34e9d8c85cd3966.jpg"
        ]
    },
    {
        "organizationId": 3249,
        "companyName": "广州华枫物流有限公司",
        "companyAddr": "白云区太和镇白云货运市场二期B1-121档",
        "lon": "113.340975",
        "lat": "23.296629",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/15/1ac6b21291084b259cb0ba73a0a211de.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "华枫物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/15/30422f986daa4dc1927132a2360917f1.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "广州市,清远市",
        "transitLocation": null,
        "timeLimitExplain": "预计1天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "莫德华",
        "servicePhoneNo": "13500026399",
        "directLineName": "广州市-广州市,清远市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/15/1ac6b21291084b259cb0ba73a0a211de.jpg"
        ]
    },
    {
        "organizationId": 3188,
        "companyName": "河南亚东物流快运有限公司",
        "companyAddr": "白云区太和镇白云货运市场二期B2栋107档",
        "lon": "113.340975",
        "lat": "23.296629",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/15/069fc5693a084f26a7a4336d2b522731.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "亚东物流",
        "companyLabel": "认证,金牌,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/15/5a1f5e2cd77e4379bfb31383129baf73.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "漯河市,驻马店市",
        "transitLocation": null,
        "timeLimitExplain": "预计3-4天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": "",
        "serverName": "杨广来",
        "servicePhoneNo": "13512735185",
        "directLineName": "广州市-漯河市,驻马店市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/15/069fc5693a084f26a7a4336d2b522731.jpg"
        ]
    },
    {
        "organizationId": 3154,
        "companyName": "河北路路通物流有限公司",
        "companyAddr": "白云区太和镇白云货运市场B1栋121档",
        "lon": "113.340975",
        "lat": "23.296629",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/15/4ff4795940fa480cacd8e46ee6808839.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/15/a41c6297a91b417f9434d4dea807699d.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "路路通物流",
        "companyLabel": "认证,金牌,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/15/1fffd773e0e6489c883c620c72f849d5.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "保定市",
        "destCity": "广州市",
        "transitLocation": null,
        "timeLimitExplain": "3天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "韩立国",
        "servicePhoneNo": "18898436869",
        "directLineName": "保定市-广州市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/15/a41c6297a91b417f9434d4dea807699d.jpg",
            "https://www.wy56.com/images/2019/03/15/4ff4795940fa480cacd8e46ee6808839.jpg"
        ]
    },
    {
        "organizationId": 3129,
        "companyName": "衢州市新峰物流有限公司",
        "companyAddr": "白云区太和镇白云货运市场北场B1栋109-111档",
        "lon": "113.340975",
        "lat": "23.296629",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/14/442d53377a114387adf0c5862b2cbdcc.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/14/cab34196a6be4dfa97bd258e9c532a62.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2019/03/14/7af8f1be426248518f211bdf718df57a.jpg",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "新峰物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/14/49d6c093c172415e99d315a2f25f8567.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "上饶市,衢州市",
        "transitLocation": null,
        "timeLimitExplain": "3天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "邵震",
        "servicePhoneNo": "18819288799",
        "directLineName": "广州市-上饶市,衢州市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/14/442d53377a114387adf0c5862b2cbdcc.jpg",
            "https://www.wy56.com/images/2019/03/14/7af8f1be426248518f211bdf718df57a.jpg",
            "https://www.wy56.com/images/2019/03/14/cab34196a6be4dfa97bd258e9c532a62.jpg"
        ]
    },
    {
        "organizationId": 3123,
        "companyName": "广平兴运物流有限公司",
        "companyAddr": "白云区太和镇白云货运市场B2栋108档",
        "lon": "113.340975",
        "lat": "23.296629",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/14/9820629cf70d4deebf9f136102e6baa3.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "广平兴运物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/14/fca6fcaa8c9b452da9752afe61f25e54.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "平顶山市",
        "transitLocation": null,
        "timeLimitExplain": "预计2-3天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "薛连伟",
        "servicePhoneNo": "15638660555",
        "directLineName": "广州市-平顶山市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/14/9820629cf70d4deebf9f136102e6baa3.jpg"
        ]
    },
    {
        "organizationId": 3118,
        "companyName": "广州韶安物流有限公司",
        "companyAddr": "白云区太和镇白云货运市场北场B1栋107档",
        "lon": "113.340975",
        "lat": "23.296629",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/14/783e69d0cb76478ead9c496411e65715.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/14/40389720ea8749a8b1604970b86a1a9d.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2019/03/14/3afb4f6172c441f69b4addac20d190b4.jpg",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "韶安物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/14/4b41ca1928d34d65b8f4adce59f5a136.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "韶关市",
        "transitLocation": null,
        "timeLimitExplain": "预计1-2日",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "林文清",
        "servicePhoneNo": "13826317335",
        "directLineName": "广州市-韶关市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/14/40389720ea8749a8b1604970b86a1a9d.jpg",
            "https://www.wy56.com/images/2019/03/14/783e69d0cb76478ead9c496411e65715.jpg",
            "https://www.wy56.com/images/2019/03/14/3afb4f6172c441f69b4addac20d190b4.jpg"
        ]
    },
    {
        "organizationId": 3069,
        "companyName": "广州市万泉物流公司",
        "companyAddr": "白云区太和镇白云货运市场二期B1栋122-123档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/14/b6d9ea1e55a44d5b86796c2e9476d171.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/14/f3818a22a9b8431fa554d0b55950d529.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "万泉物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/14/6cbba74ebb8b487d9a3640326c597682.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "南宁市",
        "transitLocation": null,
        "timeLimitExplain": "2-3天,预计1-2天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "董治平",
        "servicePhoneNo": "13728074122",
        "directLineName": "广州市-南宁市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/14/f3818a22a9b8431fa554d0b55950d529.jpg",
            "https://www.wy56.com/images/2019/03/14/b6d9ea1e55a44d5b86796c2e9476d171.jpg"
        ]
    },
    {
        "organizationId": 3067,
        "companyName": "广州市德顺物流有限公司",
        "companyAddr": "广州市太和镇白云货运市场二期C栋131档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/14/2d2bb7ac9c4746eea7606ee40ea52fed.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/14/a9965fee1a8a48f0a1f6e42aa2e1306e.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "德顺物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/14/9c9a0455e60d4edea7c904324ce3f1dc.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "海口市",
        "transitLocation": null,
        "timeLimitExplain": "预计2-3天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "方姐",
        "servicePhoneNo": "15013202313",
        "directLineName": "广州市-海口市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/14/2d2bb7ac9c4746eea7606ee40ea52fed.jpg",
            "https://www.wy56.com/images/2019/03/14/a9965fee1a8a48f0a1f6e42aa2e1306e.jpg"
        ]
    },
    {
        "organizationId": 3039,
        "companyName": "志邦物流",
        "companyAddr": "广州市白云区太和镇白云货运市场B1栋118-120档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/12/08871db6418e4fcf99581d22fbb67211.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/12/a4c96f507c4e43f5a71dc6c2cef7af16.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "志邦物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/12/b78f02f024644863a473c34f1b72b0db.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "湛江市,茂名市,阳江市",
        "transitLocation": null,
        "timeLimitExplain": "2天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "陈培冠",
        "servicePhoneNo": "18924133368",
        "directLineName": "广州市-湛江市,茂名市,阳江市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/12/08871db6418e4fcf99581d22fbb67211.jpg",
            "https://www.wy56.com/images/2019/03/12/a4c96f507c4e43f5a71dc6c2cef7af16.jpg"
        ]
    },
    {
        "organizationId": 3033,
        "companyName": "广州赢通物流有限公司",
        "companyAddr": "广州市白云区太和镇白云货运市场北场C4栋122-123档",
        "lon": "113.342825",
        "lat": "23.296815",
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/13/15a149ac6daf4c3e8b6fd25448b30b28.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "广州赢通物流有限公司",
        "companyLabel": "认证,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/13/9c56136904184ca294bec4b02aa80663.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "珠海市",
        "transitLocation": null,
        "timeLimitExplain": "预计1-2天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "王顺强",
        "servicePhoneNo": "13922356767",
        "directLineName": "广州市-珠海市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/13/15a149ac6daf4c3e8b6fd25448b30b28.jpg"
        ]
    },
    {
        "organizationId": 2807,
        "companyName": "广州高登物流有限公司",
        "companyAddr": "广东省广州市白云区太和镇沙太北路丰和物流园F5106-109档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/04/5c9a2a992af34ab1bd13e0820340d5df.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/04/e2da465fc2434a26aec8addca1a6c5b7.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2019/03/04/50ca9bdb136a44e294eefd69d82a0ef1.jpg",
        "companyImgUrl4": "https://www.wy56.com/images/2019/03/04/d33cfa417ec64adbbe1ab89a023fb3f7.jpg",
        "companyImgUrl5": "",
        "nodeNickName": "广州高登物流有限公司",
        "companyLabel": "认证,金牌,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/04/05dc0e857bd941fda77ff9033e7985d2.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "临沂市",
        "transitLocation": "",
        "timeLimitExplain": "3天",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2019/03/04/688386d4614d4e4b9900530885a9a111.jpg",
        "businessRouteLine": null,
        "serverName": "李高登",
        "servicePhoneNo": "13926009586",
        "directLineName": "广州市-临沂市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/04/5c9a2a992af34ab1bd13e0820340d5df.jpg",
            "https://www.wy56.com/images/2019/03/04/50ca9bdb136a44e294eefd69d82a0ef1.jpg",
            "https://www.wy56.com/images/2019/03/04/e2da465fc2434a26aec8addca1a6c5b7.jpg",
            "https://www.wy56.com/images/2019/03/04/d33cfa417ec64adbbe1ab89a023fb3f7.jpg"
        ]
    },
    {
        "organizationId": 2715,
        "companyName": "广州市中昊物流有限公司",
        "companyAddr": "广东省广州市白云区太和镇沙太北路丰和物流园E1013-015档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/02/a58f98e44b8b43f7b5ffa554b2a6278a.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/02/75f0f154e37b4aec94ea5e9de1daeeab.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2019/03/02/0bfa967004774a8cadf06c96535f36ec.jpg",
        "companyImgUrl4": "https://www.wy56.com/images/2019/03/02/e39dc393d7ca41a9acb5ddef82c804ce.jpg",
        "companyImgUrl5": "",
        "nodeNickName": "广州市中昊物流有限公司",
        "companyLabel": "认证,金牌,甩挂,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/02/707898fffa7c40a19fe7a83f97233501.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "聊城市",
        "transitLocation": "",
        "timeLimitExplain": "3天左右",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2019/03/02/84d8f39d7a06419bb620321035e1cf1f.jpg",
        "businessRouteLine": null,
        "serverName": "李祥宾",
        "servicePhoneNo": "13631311718",
        "directLineName": "广州市-聊城市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/02/e39dc393d7ca41a9acb5ddef82c804ce.jpg",
            "https://www.wy56.com/images/2019/03/02/a58f98e44b8b43f7b5ffa554b2a6278a.jpg",
            "https://www.wy56.com/images/2019/03/02/75f0f154e37b4aec94ea5e9de1daeeab.jpg",
            "https://www.wy56.com/images/2019/03/02/0bfa967004774a8cadf06c96535f36ec.jpg"
        ]
    },
    {
        "organizationId": 2714,
        "companyName": "广州恒创物流供应链有限公司",
        "companyAddr": "广东省广州市白云区太和镇沙太北路丰和物流园F9101-102档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/02/56768ad60071445d92b7498a89fbca4c.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/02/dd192ce3ed6a4df4905d33817dbba639.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2019/03/02/7bda3d7cb794437aab291b98461c1c2d.jpg",
        "companyImgUrl4": "https://www.wy56.com/images/2019/03/02/a2123a66952947b1aa3ea6e618311aaf.jpg",
        "companyImgUrl5": "https://www.wy56.com/images/2019/03/02/44277c2270994c729f1647c574489598.jpg",
        "nodeNickName": "广州恒创物流供应链有限公司",
        "companyLabel": "认证,金牌,甩挂,专线",
        "companyLogo": "https://www.wy56.com/images/2019/03/02/0bee514126a946f28552ae6414951be8.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "六盘水市,安顺市,毕节地区,贵阳市,遵义市,铜仁地区,黔东南苗族侗族自治州,黔南布依族苗族自治州,黔西南布依族苗族自治州",
        "transitLocation": "",
        "timeLimitExplain": "2-3天,3天,3天左右",
        "bussinessLicenseUrl": null,
        "businessRouteLine": null,
        "serverName": "李孝清",
        "servicePhoneNo": "18027475161",
        "directLineName": "广州市-六盘水市,安顺市,毕节地区,贵阳市,遵义市,铜仁地区,黔东南苗族侗族自治州,黔南布依族苗族自治州,黔西南布依族苗族自治州",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/02/7bda3d7cb794437aab291b98461c1c2d.jpg",
            "https://www.wy56.com/images/2019/03/02/44277c2270994c729f1647c574489598.jpg",
            "https://www.wy56.com/images/2019/03/02/dd192ce3ed6a4df4905d33817dbba639.jpg",
            "https://www.wy56.com/images/2019/03/02/56768ad60071445d92b7498a89fbca4c.jpg",
            "https://www.wy56.com/images/2019/03/02/a2123a66952947b1aa3ea6e618311aaf.jpg"
        ]
    },
    {
        "organizationId": 1843,
        "companyName": "荣成～广新物流",
        "companyAddr": "白云货运市场c栋125档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2018/12/25/950d42fbba894942a93834893572e3e1.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/12/25/bc0b2e755a304198a73b036480ec8cc5.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "荣成～广新物流",
        "companyLabel": "认证",
        "companyLogo": "https://www.wy56.com/images/2018/12/25/5ed1ff3cd27a4016b396379cb1b21287.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "邵阳市",
        "transitLocation": null,
        "timeLimitExplain": "2-3天",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/12/25/e0f8f85c77cb43498e86c9b9dc77a87e.jpg",
        "businessRouteLine": null,
        "serverName": "罗叶林",
        "servicePhoneNo": "13357296597",
        "directLineName": "广州市-邵阳市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/12/25/bc0b2e755a304198a73b036480ec8cc5.jpg",
            "https://www.wy56.com/images/2018/12/25/950d42fbba894942a93834893572e3e1.jpg"
        ]
    },
    {
        "organizationId": 1842,
        "companyName": "广州日亮物流",
        "companyAddr": "白云货运市场二期A2栋121-124档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2018/12/26/ceec0570a30447858ec0f337cd4c731e.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "广州日亮物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2018/12/26/02243b7c16bb45deb4205bbf147821d5.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "汕头市",
        "transitLocation": null,
        "timeLimitExplain": "2天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "李磊",
        "servicePhoneNo": "15217633456",
        "directLineName": "广州市-汕头市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/12/26/ceec0570a30447858ec0f337cd4c731e.jpg"
        ]
    },
    {
        "organizationId": 1841,
        "companyName": "广州安盛物流有限公司",
        "companyAddr": "白云货运市场B2-105档",
        "lon": "113.340313",
        "lat": "23.295902",
        "companyImgUrl1": "https://www.wy56.com/images/2018/12/26/bd13ba2bd08140b4a96425b05f92d15f.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/12/26/9ba8841d788145c8bbf744faecb79c40.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2018/12/26/990f07e0e8f04d08a064008be159df45.jpg",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "安盛物流",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2018/12/26/749cb187aa6d4b6296d247ab2aa71feb.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "安阳市",
        "transitLocation": "",
        "timeLimitExplain": "3-4天",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/12/26/6238c971ae5b45bda69a6cab40e0853a.jpg",
        "businessRouteLine": null,
        "serverName": "杨相军",
        "servicePhoneNo": "15603831888",
        "directLineName": "广州市-安阳市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/12/26/bd13ba2bd08140b4a96425b05f92d15f.jpg",
            "https://www.wy56.com/images/2018/12/26/9ba8841d788145c8bbf744faecb79c40.jpg",
            "https://www.wy56.com/images/2018/12/26/990f07e0e8f04d08a064008be159df45.jpg"
        ]
    },
    {
        "organizationId": 1827,
        "companyName": "广州市远景物流有限公司",
        "companyAddr": "广州市白云区太和镇白云物流园C1栋101/103档",
        "lon": "113.340975",
        "lat": "23.296629",
        "companyImgUrl1": "https://www.wy56.com/images/2018/12/19/fe0ba8b5d556426696f910e5b5a2bd29.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "广州市远景物流有限公司",
        "companyLabel": "往返,专线",
        "companyLogo": "https://www.wy56.com/images/2018/12/19/8358d975d3e84864a651d4068bc3746b.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "西安市",
        "transitLocation": null,
        "timeLimitExplain": "3天",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/12/19/ade339ddac2a4b90ba66910e4283d053.jpg",
        "businessRouteLine": null,
        "serverName": "张新房",
        "servicePhoneNo": "13189079071",
        "directLineName": "广州市-西安市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/12/19/fe0ba8b5d556426696f910e5b5a2bd29.jpg"
        ]
    },
    {
        "organizationId": 1818,
        "companyName": "丽城运通",
        "companyAddr": "白云货运市场A2栋137-139档",
        "lon": "113.340975",
        "lat": "23.296629",
        "companyImgUrl1": "https://www.wy56.com/images/2018/12/18/accdd8d9ac934698873052e464aa735d.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/12/18/ff72ef9663b64a30b97a04617ef425c5.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2018/12/18/9c4e47e67a544a929d175a845cdebb5c.jpg",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "丽城运通",
        "companyLabel": "往返,甩挂,认证,专线",
        "companyLogo": "https://www.wy56.com/images/2018/12/18/e6976e6d7cff4384a5cab18c1980d9d2.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "湛江市,茂名市,阳江市",
        "transitLocation": null,
        "timeLimitExplain": "2天",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/12/18/e67a795977304ccf89d799de780d328c.jpg",
        "businessRouteLine": null,
        "serverName": "郭援援",
        "servicePhoneNo": "18928871308",
        "directLineName": "广州市-湛江市,茂名市,阳江市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/12/18/ff72ef9663b64a30b97a04617ef425c5.jpg",
            "https://www.wy56.com/images/2018/12/18/accdd8d9ac934698873052e464aa735d.jpg",
            "https://www.wy56.com/images/2018/12/18/9c4e47e67a544a929d175a845cdebb5c.jpg"
        ]
    },
    {
        "organizationId": 1605,
        "companyName": "广州市华泽物流有限公司",
        "companyAddr": "广东省广州市白云区沙太北路林安物流园林安大厦A5栋503室",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/11/27/dc9241f04a594550980ce1cf384a1fb6.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "广州市华泽物流有限公司",
        "companyLabel": "认证,三方",
        "companyLogo": "https://www.wy56.com/images/2018/11/27/f9957ed74c5e41c0ae2e621a43675b63.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": null,
        "isHangUp": null,
        "startCity": null,
        "destCity": "",
        "transitLocation": null,
        "timeLimitExplain": null,
        "bussinessLicenseUrl": "",
        "businessRouteLine": "",
        "serverName": "杨成良",
        "servicePhoneNo": "18688390316",
        "directLineName": "",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/11/27/dc9241f04a594550980ce1cf384a1fb6.jpg"
        ]
    },
    {
        "organizationId": 1594,
        "companyName": "广州联杰物流有限公司",
        "companyAddr": "广东省广州市白云区太和镇大源北路林安物流园林安大厦A5栋610室",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/11/27/aabbb19a07a648c290c8740866cbfaf8.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "广州联杰物流有限公司",
        "companyLabel": "认证,三方",
        "companyLogo": "https://www.wy56.com/images/2018/11/27/7495834e164e4c1d8ddf36247ee80237.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": null,
        "isHangUp": null,
        "startCity": null,
        "destCity": "",
        "transitLocation": null,
        "timeLimitExplain": null,
        "bussinessLicenseUrl": "",
        "businessRouteLine": "",
        "serverName": "李兴荣",
        "servicePhoneNo": "13826453567",
        "directLineName": "",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/11/27/aabbb19a07a648c290c8740866cbfaf8.jpg"
        ]
    },
    {
        "organizationId": 1539,
        "companyName": "广州硕泰物流有限公司",
        "companyAddr": "广州市白云区沙太北路丰和物流园A座209档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/11/23/5665cad69a15498a9d5e181706df5d87.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/11/23/c26cbc8252f140948493b4d619e4efad.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2018/11/23/44027235ab4845808bba94fd74de1f61.jpg",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "广州硕泰物流有限公司",
        "companyLabel": "认证,金牌,三方",
        "companyLogo": "https://www.wy56.com/images/2018/11/23/f4fde69b96e7425d9a9cd1afd29c528c.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": null,
        "isHangUp": null,
        "startCity": null,
        "destCity": "",
        "transitLocation": null,
        "timeLimitExplain": null,
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/11/23/ac983887ab9f4b0eafa8cba6283e9729.jpg",
        "businessRouteLine": null,
        "serverName": "李小花",
        "servicePhoneNo": "13640207698",
        "directLineName": "",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/11/23/5665cad69a15498a9d5e181706df5d87.jpg",
            "https://www.wy56.com/images/2018/11/23/c26cbc8252f140948493b4d619e4efad.jpg",
            "https://www.wy56.com/images/2018/11/23/44027235ab4845808bba94fd74de1f61.jpg"
        ]
    },
    {
        "organizationId": 1538,
        "companyName": "广州赣鑫物流有限公司",
        "companyAddr": "广东省广州市白云区沙太北路丰和物流园A栋215档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/11/23/4f50658604fe40fa8092ccbea1b17a60.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/11/23/c8630e60c8f347f88f43cfdd1072e580.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "广州赣鑫物流有限公司",
        "companyLabel": "认证,金牌,三方",
        "companyLogo": "https://www.wy56.com/images/2018/11/23/85aed8708016434bbaecd5ebe8f64cdd.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": null,
        "isHangUp": null,
        "startCity": null,
        "destCity": "",
        "transitLocation": null,
        "timeLimitExplain": null,
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/11/23/969a6cf6b7df4c0da1be9482f6efc5ea.jpg",
        "businessRouteLine": null,
        "serverName": "邹拥军",
        "servicePhoneNo": "13826169076",
        "directLineName": "",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/11/23/c8630e60c8f347f88f43cfdd1072e580.jpg",
            "https://www.wy56.com/images/2018/11/23/4f50658604fe40fa8092ccbea1b17a60.jpg"
        ]
    },
    {
        "organizationId": 1537,
        "companyName": "广州聚创物流有限公司",
        "companyAddr": "广东省广州市白云区沙太北路丰和物流园A211档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/11/23/c31925f90cc640d6a784c390909b2662.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/11/23/cb2be53417914531a0efec1844442d39.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2018/11/23/0179ac4da94047f1ab2531453e0e7bfb.jpg",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "广州聚创物流有限公司",
        "companyLabel": "认证,金牌,三方",
        "companyLogo": "https://www.wy56.com/images/2018/11/23/d3fc29d1fd3944458b0a91b6f123b6e8.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": null,
        "isHangUp": null,
        "startCity": null,
        "destCity": "",
        "transitLocation": null,
        "timeLimitExplain": null,
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/11/23/d15fa221172e40deb95fa43340285f31.jpg",
        "businessRouteLine": null,
        "serverName": "肖赟",
        "servicePhoneNo": "18928769656",
        "directLineName": "",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/11/23/0179ac4da94047f1ab2531453e0e7bfb.jpg",
            "https://www.wy56.com/images/2018/11/23/cb2be53417914531a0efec1844442d39.jpg",
            "https://www.wy56.com/images/2018/11/23/c31925f90cc640d6a784c390909b2662.jpg"
        ]
    },
    {
        "organizationId": 1305,
        "companyName": "山东德扬物流有限公司",
        "companyAddr": "广东省广州市白云区太和镇林安物流园五街510-516档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/11/06/4cc156f3f8894d54bcee8f9c17f5a5ff.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "山东德扬物流有限公司",
        "companyLabel": "认证,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2018/11/06/eaaedfe5fb4c458f9c3efd842ab4f725.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "济南市",
        "transitLocation": "",
        "timeLimitExplain": "3-4天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "王总",
        "servicePhoneNo": "13805392160",
        "directLineName": "广州市-济南市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/11/06/4cc156f3f8894d54bcee8f9c17f5a5ff.jpg"
        ]
    },
    {
        "organizationId": 1288,
        "companyName": "广州华喆物流有限公司",
        "companyAddr": "广东省广州市白云区太和镇林安物流园六街601-603档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/11/06/47129f5e41b84439a38b246cfe7ad172.jpg",
        "companyImgUrl2": "",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "广州华喆物流有限公司",
        "companyLabel": "认证,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2018/11/06/4f7085ea6f0443ce9227c95087ea7486.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "郑州市",
        "transitLocation": "",
        "timeLimitExplain": "2-3天",
        "bussinessLicenseUrl": "",
        "businessRouteLine": null,
        "serverName": "梁涛",
        "servicePhoneNo": "13710390081",
        "directLineName": "广州市-郑州市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/11/06/47129f5e41b84439a38b246cfe7ad172.jpg"
        ]
    },
    {
        "organizationId": 1244,
        "companyName": "广东振禹物流有限公司",
        "companyAddr": "广东省广州市白云区沙太北路丰和物流园E6016-022档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/10/29/a813d0b6da924fe590af4f9890f5d4ed.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/10/29/8f055e6a3130488ba21cc37d82f7166c.jpg",
        "companyImgUrl3": "",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "广东振禹物流有限公司",
        "companyLabel": "认证,往返,专线,仓储,金牌",
        "companyLogo": "https://www.wy56.com/images/2018/10/29/278fea638c384648a861e428b442884e.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "东莞市,中山市,广州市,成都市,汕头市,海口市,深圳市,湛江市,重庆市",
        "destCity": "合肥市,济南市",
        "transitLocation": "",
        "timeLimitExplain": "3-4天,3天",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/10/29/de195691e6d944f5906f50fc787646e9.jpg",
        "businessRouteLine": null,
        "serverName": "张宪龙",
        "servicePhoneNo": "15602208488",
        "directLineName": "东莞市,中山市,广州市,成都市,汕头市,海口市,深圳市,湛江市,重庆市-合肥市,济南市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/10/29/8f055e6a3130488ba21cc37d82f7166c.jpg",
            "https://www.wy56.com/images/2018/10/29/a813d0b6da924fe590af4f9890f5d4ed.jpg"
        ]
    },
    {
        "organizationId": 1243,
        "companyName": "广州盛兴物流有限公司",
        "companyAddr": "广东省广州市白云区沙太北路丰和物流园C2109-111档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/10/25/1c2d5f907b124729b06dc6e61ed98bfc.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/10/25/958a1cc5417440bbb4bfb5e21e657ce5.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2018/10/25/525a5ee4a7c54c33805cc21ce4123bcd.jpg",
        "companyImgUrl4": "https://www.wy56.com/images/2018/10/25/05d7109acb45420f94454ff9a1b6d632.jpg",
        "companyImgUrl5": "",
        "nodeNickName": "广州盛兴物流有限公司",
        "companyLabel": "认证,往返,金牌,专线",
        "companyLogo": "https://www.wy56.com/images/2018/10/25/62367a1f8d87437c8a04ad5ff461afc7.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "金华市",
        "transitLocation": "",
        "timeLimitExplain": "2-3天",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/10/25/a55214ebff3142e2a477c1d795af2626.jpg",
        "businessRouteLine": null,
        "serverName": "沈佳骏",
        "servicePhoneNo": "13570051243",
        "directLineName": "广州市-金华市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/10/25/1c2d5f907b124729b06dc6e61ed98bfc.jpg",
            "https://www.wy56.com/images/2018/10/25/958a1cc5417440bbb4bfb5e21e657ce5.jpg",
            "https://www.wy56.com/images/2018/10/25/525a5ee4a7c54c33805cc21ce4123bcd.jpg",
            "https://www.wy56.com/images/2018/10/25/05d7109acb45420f94454ff9a1b6d632.jpg"
        ]
    },
    {
        "organizationId": 1242,
        "companyName": "江西大飞物流有限公司广州分公司（丰和）",
        "companyAddr": "广东省广州市白云区丰和物流园D5003-006档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2019/03/01/62bb71d83f54451cb2f77447949b23ce.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/03/01/a34a616c70c24d55b080a2dfa13be330.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2019/03/01/072d850f0a7045f9b8b7741803b9676b.jpg",
        "companyImgUrl4": "https://www.wy56.com/images/2019/03/01/8574b533e34a4e2f981cbf369069710b.jpg",
        "companyImgUrl5": "",
        "nodeNickName": "江西大飞物流有限公司广州分公司（丰和）",
        "companyLabel": "认证,往返,金牌,专线",
        "companyLogo": "https://www.wy56.com/images/2018/10/23/0a3dd39dde6c411da40ea0b7db2021c2.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "东莞市,广州市",
        "destCity": "杭州市",
        "transitLocation": "",
        "timeLimitExplain": "2-3天",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2019/03/01/5fe579156b2a4fa1a2225b9efa70d628.jpg",
        "businessRouteLine": null,
        "serverName": "张文涛经理",
        "servicePhoneNo": "17722336170",
        "directLineName": "东莞市,广州市-杭州市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/03/01/072d850f0a7045f9b8b7741803b9676b.jpg",
            "https://www.wy56.com/images/2019/03/01/a34a616c70c24d55b080a2dfa13be330.jpg",
            "https://www.wy56.com/images/2019/03/01/62bb71d83f54451cb2f77447949b23ce.jpg",
            "https://www.wy56.com/images/2019/03/01/8574b533e34a4e2f981cbf369069710b.jpg"
        ]
    },
    {
        "organizationId": 1229,
        "companyName": "扬州华龙物流有限公司",
        "companyAddr": "广东省广州市白云区沙太北路丰和物流园E4016档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/10/31/c4062010c54a4ccc95df19daff27373f.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/10/31/d088a6a802d049bd807c3142faa6d929.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2018/10/31/fa745924e03c4ab2adccd69a6fefb28a.jpg",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "扬州华龙物流有限公司",
        "companyLabel": "认证,仓储",
        "companyLogo": "https://www.wy56.com/images/2018/10/31/161dcd979a644dd8bbb17e303ae8c1b6.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": null,
        "isHangUp": null,
        "startCity": null,
        "destCity": "",
        "transitLocation": null,
        "timeLimitExplain": null,
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/10/31/b89687e999594ce4b84579671f7e002a.jpg",
        "businessRouteLine": null,
        "serverName": "宋志毅",
        "servicePhoneNo": "13905276767",
        "directLineName": "",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/10/31/fa745924e03c4ab2adccd69a6fefb28a.jpg",
            "https://www.wy56.com/images/2018/10/31/d088a6a802d049bd807c3142faa6d929.jpg",
            "https://www.wy56.com/images/2018/10/31/c4062010c54a4ccc95df19daff27373f.jpg"
        ]
    },
    {
        "organizationId": 1228,
        "companyName": "广州正广通供应链管理有限公司",
        "companyAddr": "广东省广州市白云区沙太北路丰和物流园E6001-008档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/10/31/4ca1844e6eef460d977940f9bf5dbc9b.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/10/31/34604c24af684d62858f762545ad4700.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2018/10/31/50dde03bf9a241f1831eaa7c1f6eca98.jpg",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "广州正广通供应链管理有限公司",
        "companyLabel": "认证,金牌,仓储",
        "companyLogo": "https://www.wy56.com/images/2018/10/31/26007621443c49f2a9a0b2b539f7e3fc.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": null,
        "isHangUp": null,
        "startCity": null,
        "destCity": "",
        "transitLocation": null,
        "timeLimitExplain": null,
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/10/31/2e272c5216574465a4c95786c8d12771.jpg",
        "businessRouteLine": null,
        "serverName": "李国忠",
        "servicePhoneNo": "13924209758",
        "directLineName": "",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/10/31/34604c24af684d62858f762545ad4700.jpg",
            "https://www.wy56.com/images/2018/10/31/50dde03bf9a241f1831eaa7c1f6eca98.jpg",
            "https://www.wy56.com/images/2018/10/31/4ca1844e6eef460d977940f9bf5dbc9b.jpg"
        ]
    },
    {
        "organizationId": 1227,
        "companyName": "广州市茂豪物流有限公司",
        "companyAddr": "广东省广州市白云区沙太北路丰和物流园E4009-010档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/10/31/768ed71b67d2413d9b080762da00e210.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/10/31/214209171dfe47208fe61859ee0d3b68.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2018/10/31/d561a917f412454bbb48138a042e41ef.jpg",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "广州市茂豪物流有限公司",
        "companyLabel": "认证,仓储",
        "companyLogo": "https://www.wy56.com/images/2018/10/31/d5ab56c87aed407ab1e073b38d408e38.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": null,
        "isHangUp": null,
        "startCity": null,
        "destCity": "",
        "transitLocation": null,
        "timeLimitExplain": null,
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/10/31/de6044224bb541e9bc0c69019e2ec519.jpg",
        "businessRouteLine": null,
        "serverName": "方振枝",
        "servicePhoneNo": "18320025885",
        "directLineName": "",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/10/31/d561a917f412454bbb48138a042e41ef.jpg",
            "https://www.wy56.com/images/2018/10/31/768ed71b67d2413d9b080762da00e210.jpg",
            "https://www.wy56.com/images/2018/10/31/214209171dfe47208fe61859ee0d3b68.jpg"
        ]
    },
    {
        "organizationId": 1226,
        "companyName": "广州锦胜物流有限公司",
        "companyAddr": "广东省广州市白云区沙太北路丰和物流园F2101-105档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2019/02/27/ef48cb0a1da942e7bdc12e61a501ca42.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2019/02/27/6441375dd8a949f38839d57ccd999bf2.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2019/02/27/e71c55de61d74f19a859b1cf1044aab9.jpg",
        "companyImgUrl4": "https://www.wy56.com/images/2019/02/27/d9b081bf8b934c44867e175310c74b64.jpg",
        "companyImgUrl5": "",
        "nodeNickName": "广州锦胜物流有限公司",
        "companyLabel": "认证,金牌,专线,仓储",
        "companyLogo": "https://www.wy56.com/images/2019/02/27/82038d381c3641de983e317bd8f856cb.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "佛山市,广州市",
        "destCity": "临沂市,潍坊市",
        "transitLocation": "",
        "timeLimitExplain": "2-3天,3天",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/10/31/2aac95cf37c84e06b4d3060fd22582cb.jpg",
        "businessRouteLine": null,
        "serverName": "刘春来",
        "servicePhoneNo": "13078851777",
        "directLineName": "佛山市,广州市-临沂市,潍坊市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2019/02/27/ef48cb0a1da942e7bdc12e61a501ca42.jpg",
            "https://www.wy56.com/images/2019/02/27/6441375dd8a949f38839d57ccd999bf2.jpg",
            "https://www.wy56.com/images/2019/02/27/d9b081bf8b934c44867e175310c74b64.jpg",
            "https://www.wy56.com/images/2019/02/27/e71c55de61d74f19a859b1cf1044aab9.jpg"
        ]
    },
    {
        "organizationId": 1225,
        "companyName": "广州新球物流有限公司",
        "companyAddr": "广东省广州市白云沙太北路丰和物流园F61",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/10/29/70a249cf093e4ff2b4ad1dbb6c516711.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/10/29/ced719f3ae7c4c89b6a8d8437fd7b22c.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2018/10/29/4ac938d78ec2409d90193c97cdb98a2e.jpg",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "广州新球物流有限公司",
        "companyLabel": "认证,专线,金牌",
        "companyLogo": "https://www.wy56.com/images/2018/10/29/624a92de7d884b8e8912a73c666d809f.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "西安市",
        "transitLocation": "",
        "timeLimitExplain": "3天左右",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/10/29/9196a399fcf64638bf07aa34adc6429a.jpg",
        "businessRouteLine": null,
        "serverName": "邓权一",
        "servicePhoneNo": "13925011018",
        "directLineName": "广州市-西安市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/10/29/70a249cf093e4ff2b4ad1dbb6c516711.jpg",
            "https://www.wy56.com/images/2018/10/29/4ac938d78ec2409d90193c97cdb98a2e.jpg",
            "https://www.wy56.com/images/2018/10/29/ced719f3ae7c4c89b6a8d8437fd7b22c.jpg"
        ]
    },
    {
        "organizationId": 1224,
        "companyName": "广州市京珠物流有限公司",
        "companyAddr": "广东省广州市白云区沙太北路丰和物流园E1004-008档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/10/29/025ce9a6b841450eae5ae24b4fb0f8f3.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/10/29/9038bf3975d544ae8e6cd804219ece55.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2018/10/29/0dd3f99adc0e451dae1bbc4be1bde082.jpg",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "广州市京珠物流有限公司",
        "companyLabel": "认证,金牌,专线",
        "companyLogo": "https://www.wy56.com/images/2018/10/29/ea620768be874474949974a350ead0b5.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "南宁市",
        "transitLocation": "",
        "timeLimitExplain": "1-2天",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/10/29/fd67b465c2a347a985f15282d40b1892.jpg",
        "businessRouteLine": null,
        "serverName": "宁波",
        "servicePhoneNo": "13450476822",
        "directLineName": "广州市-南宁市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/10/29/0dd3f99adc0e451dae1bbc4be1bde082.jpg",
            "https://www.wy56.com/images/2018/10/29/9038bf3975d544ae8e6cd804219ece55.jpg",
            "https://www.wy56.com/images/2018/10/29/025ce9a6b841450eae5ae24b4fb0f8f3.jpg"
        ]
    },
    {
        "organizationId": 1223,
        "companyName": "广州市飞鹏物流有限公司",
        "companyAddr": "广东省广州市白云区沙太北路丰和物流园E1009-012档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/10/29/ac20a00a122947ae9a6fd021a5daf8b3.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/10/29/e2c587ad9d1e47eb8286cb83e52e6bc9.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2018/10/29/17530f5d515443bbbdba5b5656cf963f.jpg",
        "companyImgUrl4": "https://www.wy56.com/images/2018/10/29/312c0c50b8fd4df9bf55afc7216b50f8.jpg",
        "companyImgUrl5": "",
        "nodeNickName": "广州市飞鹏物流有限公司",
        "companyLabel": "认证,金牌,专线",
        "companyLogo": "https://www.wy56.com/images/2018/10/29/b155c434b7d9417da4d5ef346c21c596.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "上海市",
        "transitLocation": "",
        "timeLimitExplain": "1-3天",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/10/29/fd67b465c2a347a985f15282d40b1892.jpg",
        "businessRouteLine": null,
        "serverName": "邓琳波",
        "servicePhoneNo": "13760685446",
        "directLineName": "广州市-上海市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/10/29/312c0c50b8fd4df9bf55afc7216b50f8.jpg",
            "https://www.wy56.com/images/2018/10/29/17530f5d515443bbbdba5b5656cf963f.jpg",
            "https://www.wy56.com/images/2018/10/29/e2c587ad9d1e47eb8286cb83e52e6bc9.jpg",
            "https://www.wy56.com/images/2018/10/29/ac20a00a122947ae9a6fd021a5daf8b3.jpg"
        ]
    },
    {
        "organizationId": 1222,
        "companyName": "江西省靖安环宇运输有限公司",
        "companyAddr": "广东省广州市白云区沙太北路丰和物流园A219档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/10/29/c8d2d0c094aa4be9914ca9a44ee1a1b4.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/10/29/e03c782124b94577bd8d964999d547ab.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2018/10/29/db412d5d50a74cad900db53cbdb0d90b.jpg",
        "companyImgUrl4": "https://www.wy56.com/images/2018/10/29/bb7f2f6d3f204348b2da7f9ca37e4c60.jpg",
        "companyImgUrl5": "",
        "nodeNickName": "江西省靖安环宇运输有限公司",
        "companyLabel": "认证,金牌,三方",
        "companyLogo": "https://www.wy56.com/images/2018/10/29/1694d6b9f42547638c4586d188de0be6.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "宜春市",
        "transitLocation": "",
        "timeLimitExplain": "1-3天",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/10/29/97321732ccfc4247b81e01a274058064.jpg",
        "businessRouteLine": null,
        "serverName": "戴佰军",
        "servicePhoneNo": "13925058446",
        "directLineName": "广州市-宜春市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/10/29/c8d2d0c094aa4be9914ca9a44ee1a1b4.jpg",
            "https://www.wy56.com/images/2018/10/29/e03c782124b94577bd8d964999d547ab.jpg",
            "https://www.wy56.com/images/2018/10/29/bb7f2f6d3f204348b2da7f9ca37e4c60.jpg",
            "https://www.wy56.com/images/2018/10/29/db412d5d50a74cad900db53cbdb0d90b.jpg"
        ]
    },
    {
        "organizationId": 1221,
        "companyName": "上海鹏景物流有限公司",
        "companyAddr": "广东省广州市白云区沙太北路丰和物流园E6015档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/10/29/290044b7d045433b816fc05ed8055c67.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/10/29/086e4afd323341ba9cee5f8a25429d47.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2018/10/29/edd994c89def4ce88b7feaea0bdd4b3b.jpg",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "上海鹏景物流有限公司",
        "companyLabel": "认证,仓储,专线,金牌",
        "companyLogo": "https://www.wy56.com/images/2018/10/29/e79616d1ffe544d19ba994430deff7d4.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "上海市",
        "transitLocation": "",
        "timeLimitExplain": "3天左右",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/10/29/9e8bb6121bd740cd82b865168ebf3557.jpg",
        "businessRouteLine": null,
        "serverName": "蒋武",
        "servicePhoneNo": "13922157689",
        "directLineName": "广州市-上海市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/10/29/290044b7d045433b816fc05ed8055c67.jpg",
            "https://www.wy56.com/images/2018/10/29/086e4afd323341ba9cee5f8a25429d47.jpg",
            "https://www.wy56.com/images/2018/10/29/edd994c89def4ce88b7feaea0bdd4b3b.jpg"
        ]
    },
    {
        "organizationId": 1220,
        "companyName": "广州鼎豪物流有限公司",
        "companyAddr": "广东省广州市白云区沙太北路丰和物流园E4001-002档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/10/29/d6bd22ecdb5d46f28e23502adfbf2ad9.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/10/29/73d455b28b77499caab618d5c487f93b.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2018/10/29/1e331c0975db40dca7059412d9686996.jpg",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "广州鼎豪物流有限公司",
        "companyLabel": "认证,仓储,专线",
        "companyLogo": "https://www.wy56.com/images/2018/10/29/595d07e22a1c4e3989cc3b627741552d.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "沧州市",
        "transitLocation": "",
        "timeLimitExplain": "3天",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/10/29/cc0a6eab519f4b17a25a06e195bafc55.jpg",
        "businessRouteLine": null,
        "serverName": "王永福",
        "servicePhoneNo": "13932897255",
        "directLineName": "广州市-沧州市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/10/29/1e331c0975db40dca7059412d9686996.jpg",
            "https://www.wy56.com/images/2018/10/29/73d455b28b77499caab618d5c487f93b.jpg",
            "https://www.wy56.com/images/2018/10/29/d6bd22ecdb5d46f28e23502adfbf2ad9.jpg"
        ]
    },
    {
        "organizationId": 1219,
        "companyName": "陕西秦龙物流有限公司",
        "companyAddr": "广东省广州市白云区沙太北路丰和物流E5001-002档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/10/29/b1378f0144404c04a5bb083b34d89064.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/10/29/455df70742e440f19fc8756105b8d517.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2018/10/29/f1cf6cba38884d1383e95a5492c1f752.jpg",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "陕西秦龙物流有限公司",
        "companyLabel": "认证,三方,专线,金牌,甩挂",
        "companyLogo": "https://www.wy56.com/images/2018/10/29/184c54bec6ab4fed949c9c1449fb0c8b.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "中山市,广州市",
        "destCity": "乌鲁木齐市",
        "transitLocation": "",
        "timeLimitExplain": "3天",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/10/29/c74fcffd9017489cbf7c288b63962430.jpg",
        "businessRouteLine": null,
        "serverName": "姚西锋",
        "servicePhoneNo": "13924200457",
        "directLineName": "中山市,广州市-乌鲁木齐市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/10/29/455df70742e440f19fc8756105b8d517.jpg",
            "https://www.wy56.com/images/2018/10/29/f1cf6cba38884d1383e95a5492c1f752.jpg",
            "https://www.wy56.com/images/2018/10/29/b1378f0144404c04a5bb083b34d89064.jpg"
        ]
    },
    {
        "organizationId": 1218,
        "companyName": "常州市鹏鑫程运输有限公司",
        "companyAddr": "广东省广州市白云区沙太北路丰和物流园汽配街16档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/10/29/03d9955710204385a9efbe18b9936a7a.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/10/29/dcc4a3332815414bb5ead599f46f437d.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2018/10/29/c7746ee7830149c3ad52e99f54bd233d.jpg",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "常州市鹏鑫程运输有限公司",
        "companyLabel": "认证,金牌,往返,专线",
        "companyLogo": "https://www.wy56.com/images/2018/10/29/7c0a7a3e176b47beace36c9b2f2ef02b.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "东莞市,中山市,广州市",
        "destCity": "常州市",
        "transitLocation": "",
        "timeLimitExplain": "2-3天",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/10/29/9a949a2f8f60465888d914600a2677d6.jpg",
        "businessRouteLine": null,
        "serverName": "杨浩",
        "servicePhoneNo": "18655706213",
        "directLineName": "东莞市,中山市,广州市-常州市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/10/29/dcc4a3332815414bb5ead599f46f437d.jpg",
            "https://www.wy56.com/images/2018/10/29/03d9955710204385a9efbe18b9936a7a.jpg",
            "https://www.wy56.com/images/2018/10/29/c7746ee7830149c3ad52e99f54bd233d.jpg"
        ]
    },
    {
        "organizationId": 1217,
        "companyName": "郑州奥辉物流运输有限公司广州分公司",
        "companyAddr": "广东省广州市白云区沙太北路丰和物流园F9109档",
        "lon": null,
        "lat": null,
        "companyImgUrl1": "https://www.wy56.com/images/2018/10/29/3484a2647545468db891df42eb25c131.jpg",
        "companyImgUrl2": "https://www.wy56.com/images/2018/10/29/e4aee1edec1a45758917cdc8fa2ff43a.jpg",
        "companyImgUrl3": "https://www.wy56.com/images/2018/10/29/60985e30b25d4db1ae51c4a5510b3138.jpg",
        "companyImgUrl4": "",
        "companyImgUrl5": "",
        "nodeNickName": "郑州奥辉物流运输有限公司广州分公司",
        "companyLabel": "认证,专线,金牌",
        "companyLogo": "https://www.wy56.com/images/2018/10/29/8ab45502a89944a8aea9ffbf1c46c24c.jpg",
        "facadePhoteUrl": null,
        "companyCheckStatus": "1",
        "companyLevel": "1",
        "isReturn": 0,
        "isHangUp": 0,
        "startCity": "广州市",
        "destCity": "郑州市",
        "transitLocation": "",
        "timeLimitExplain": "3天",
        "bussinessLicenseUrl": "https://www.wy56.com/images/2018/10/29/69b09217dda54affa1a69f7a4412f901.jpg",
        "businessRouteLine": null,
        "serverName": "张海军",
        "servicePhoneNo": "13600489296",
        "directLineName": "广州市-郑州市",
        "companyImgUrl": [
            "https://www.wy56.com/images/2018/10/29/60985e30b25d4db1ae51c4a5510b3138.jpg",
            "https://www.wy56.com/images/2018/10/29/e4aee1edec1a45758917cdc8fa2ff43a.jpg",
            "https://www.wy56.com/images/2018/10/29/3484a2647545468db891df42eb25c131.jpg"
        ]
    }
]